function getRecentlyViewedProducts() {
  try {
    return JSON.parse(localStorage.getItem('recently_viewed_products')) || [];
  } catch (e) {
    return [];
  }
}

/* PC popup */
function renderRecentlyViewedPopup() {
  const content = document.getElementById('rvContent');
  if (!content) return;

  const viewed = getRecentlyViewedProducts();

  if (!viewed.length) {
    content.innerHTML = '<div class="rv-empty">No recently viewed products.</div>';
    return;
  }

  content.innerHTML = viewed.slice(0, 8).map(product => {
    const image = product.image || product.featured_image || '';
    return `
      <a href="${product.url || '#'}" class="rv-item">
        ${image ? `<img src="${image}" alt="${product.title || ''}" loading="lazy">` : ''}
        <div class="rv-item__title">${product.title || ''}</div>
      </a>
    `;
  }).join('');
}

/* Mobile search panel */
function renderMobileRecentlyViewed() {
  if (window.innerWidth > 768) return;

  const openSearch = document.querySelector('.header__search details[open]');
  if (!openSearch) return;

  const input = openSearch.querySelector('.search__input');
  const target = openSearch.querySelector('.recently-viewed-mobile-target');
  window.rvRecentlyViewedTitle = target.dataset.rvTitle || 'Recently Viewed';

  if (!input || !target) return;

  const hasSearchTerm = input.value.trim().length > 0;
const currentState = hasSearchTerm ? 'hidden' : 'visible';

if (target.dataset.rvState === currentState && target.innerHTML.trim() !== '') {
  return;
}

target.dataset.rvState = currentState;
  if (hasSearchTerm) {
    target.innerHTML = '';
    target.classList.add('is-hidden');
    return;
  }

  const viewed = getRecentlyViewedProducts();

  if (!viewed.length) {
    target.innerHTML = '';
    target.classList.add('is-hidden');
    return;
  }

  target.classList.remove('is-hidden');

  target.innerHTML = `
    <div class="rv-mobile-block">
   <div class="rv-mobile-title">${window.rvRecentlyViewedTitle || 'Recently Viewed'}</div>
      <div class="rv-mobile-list">
        ${viewed.slice(0, 6).map(product => {
          const image = product.image || product.featured_image || '';
          return `
            <a href="${product.url || '#'}" class="rv-mobile-item">
              ${image ? `<img src="${image}" alt="${product.title || ''}" loading="lazy">` : ''}
              <div class="rv-mobile-name">${product.title || ''}</div>
            </a>
          `;
        }).join('')}
      </div>
    </div>
  `;
}

document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.getElementById('rvTrigger');
  const popup = document.getElementById('rvPopup');
  const close = document.getElementById('rvClose');

  /* PC */
  if (trigger && popup) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      popup.classList.toggle('is-active');
      renderRecentlyViewedPopup();
    });

    if (close) {
      close.addEventListener('click', function () {
        popup.classList.remove('is-active');
      });
    }

    document.addEventListener('click', function (e) {
      if (!popup.contains(e.target) && !trigger.contains(e.target)) {
        popup.classList.remove('is-active');
      }
    });
  }

  /* Mobile */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__icon--search') || e.target.closest('.header__search')) {
      setTimeout(renderMobileRecentlyViewed, 100);
      setTimeout(renderMobileRecentlyViewed, 400);
      setTimeout(renderMobileRecentlyViewed, 800);
    }

    if (e.target.closest('.reset__button')) {
      setTimeout(renderMobileRecentlyViewed, 100);
      setTimeout(renderMobileRecentlyViewed, 300);
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList.contains('search__input')) {
      renderMobileRecentlyViewed();
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.target && e.target.classList.contains('search__input')) {
      renderMobileRecentlyViewed();
    }
  });
});